export enum LoiErrorMessage {
  CONTACT_INFO_NOT_EXISTS_ERROR_MSG = 'Letter of Intent cannot be generated because Manufacturer Name and LOB are ' +
    'missing in Contact Info table.',

  LOI_TEMPLATE_IS_MISSING_MSG = 'Letter Of Intent Template is mandatory for generating Cover Letter, contact your ' +
    'Company Administrator to add one.',
  DOWNLOAD_LOI_ERROR_MSG = 'There was an error while fetching Letter of Intent. Please try again later.',
}
